<template>
  <v-dialog
    v-model="dialog"
    width="100%"
  >
    <template v-slot:activator="{ on }">
      <v-btn style='margin: 2px' color="primary" type="icon" :disabled='disabled' v-on="on" ref='activatorButton'>
        Añadir Firmante<v-icon>mdi-account-plus</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>Agregar Firmante</v-card-title>
      <v-card-text>
        <v-data-table
          v-model="selectedContacto"
          :headers="headers"
          :items="contactos"
          single-select
          show-select
          @click:row="rowSelected"
          :loading="loading"
          :options.sync='options'
          :server-items-length="total"
          :footer-props='{
            itemsPerPageOptions: [5, 10, 20, 50]
          }'
          no-data-text="No hay contactos disponibles">
          <template v-slot:top>
            <slotbar fluid :visible='dialog' :slots='2' :slotWidth='230'>
              <template v-slot:slot1></template>
              <template v-slot:slot2>
                <v-btn color='primary' title='Agregar contacto' @click='openComponent("addContactoComponent")'>
                  Agregar Contacto<v-icon>mdi-account-plus</v-icon>
                </v-btn>
                <addContacto @reload='pageEventHandler' ref='addContactoComponent' hidden></addContacto>
              </template>
            </slotbar>
          </template>
        </v-data-table>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <slotbar fluid :visible='dialog' :slots='3' :slotWidth='320'>
          <template v-slot:slot1>
            <v-toolbar flat>
              <v-text-field
                v-model="firmante.razon"
                label="Rol del firmante"
                placeholder="Rol"
                outlined
              ></v-text-field>
            </v-toolbar>
          </template>

          <template v-slot:slot2>
            <v-toolbar flat>
              <v-select
                v-if="hasFields"
                v-model="campo"
                :items="fields"
                filled
                label="Campos de Firma"
              >
                <template v-slot:prepend>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" color="primary">mdi-information</v-icon>
                    </template>
                    <span>
                      Un campo de firma es un espacio reservado en un<br>
                      documento para un firmante en particular.<br>
                      Cada campo de firma tiene un nombre o identificador.<br>
                    </span>
                  </v-tooltip>
                </template>
              </v-select>
            </v-toolbar>
          </template>

          <template v-slot:slot3>
            <v-btn
              color="primary"
              text
              :disabled="awaitingResponse"
              @click="$emit('verFirmantesEvent')"
            >
              Ver Firmantes
            </v-btn>
            <v-btn
              color="primary"
              text
              :disabled="awaitingResponse"
              @click="AddFirmante()"
            >
              Agregar
            </v-btn>
            <v-btn
              color="primary"
              text
              @click="dialog = false"
            >
              Cerrar
            </v-btn>
          </template>
        </slotbar>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import addContacto from '@/components/contactos/addContacto.vue'
  import slotbar from '@/components/custom/slotbar.vue'
  import { consoleErrorMessage, toasterErrorMessage } from '@/utils/responseCatchMessages.js';
  import { removeWhitespace } from '@/utils/checkQuery.js';
  import { tryClick } from '@/utils/tryClick.js';
  export default {
    components:{
      addContacto,
      slotbar,
    },
    props: {
      doc: Array,
      disabled: Boolean,
    },
    data () {
      return {
        dialog: false,
        loading: false,
        campo: '',
        contactos: [],
        fields: [],
        selectedContacto: [],
        firmante: {
          contacto: {},
          razon: '',
        },
        headers: [
          { text: 'Nombre', value: 'nombre'},
          { text: 'Correo', value: 'correo'},
          { text: 'RFC', value: 'rfc' },
          { text: 'Razon Social', value: 'razonSocial' },
          { text: 'SMS', value: 'sms' },
        ],
        options: {
          sortBy: [],
          itemsPerPage: 5,
        },
        total: 0,
        awaitingResponse: false,
        firstLoad: true,
      }
    },
    computed: {
      readyToAdd() {
        if (this.selectedContacto.length > 0 && removeWhitespace(this.firmante.razon).length > 0) return true;
        return false;
      },
      hasFields() {
        if (Array.isArray(this.fields) && this.fields.length > 0) return true;
        return false;
      },
    },
    methods:{
      pageEventHandler(){
        this.getFields();
        this.listContactos();
        // this.getDocumento();
      },
      async getFields(){
        try {
          const id = this.doc[0].id;
          const clienteId = this.$store.getters.getClient;
          const result = await this.$store.dispatch('getFields',{id, clienteId});
          if (result === null) {
            this.$toast.error("No hay campos disponibles");
            return;
          }
          this.fields = result;
          console.log("Campos:%o", result);
        } catch (e) {
          consoleErrorMessage(e, defaultConsoleMessage);
          toasterErrorMessage(this.$toast.error, e, defaultToastMessage);
        }
      },
      async getDocumento(){
        const defaultToastMessage = 'Error al obtener el documento.';
        const defaultConsoleMessage = 'getDocumento error';
        try {
          const docId = this.doc[0].id;
          const clienteId = this.$store.getters.getClient;
          const result = await this.$store.dispatch('getDocumento',{docId, clienteId});
          if (result === null) {
            console.error(defaultConsoleMessage);
            this.$toast.error(defaultToastMessage);
            return;
          }
          console.log("DOCUMENTO:%o", result);
        } catch (e) {
          consoleErrorMessage(e, defaultConsoleMessage);
          toasterErrorMessage(this.$toast.error, e, defaultToastMessage);
        }
      },
      async listContactos(){
        const defaultToastMessage = 'Error al obtener la lista de contactos.';
        const defaultConsoleMessage = 'listContactos error';
        try {
          const clienteId = this.$store.getters.getClient;
          const options = this.options;
          const result = await this.$store.dispatch('listContactos',{clienteId, options});
          if (result === null) {
            console.error(defaultConsoleMessage);
            this.$toast.error(defaultToastMessage);
            return;
          }
          this.total = result.totalElements;
          this.contactos = result.content;
        }catch (e) {
          consoleErrorMessage(e, defaultConsoleMessage);
          toasterErrorMessage(this.$toast.error, e, defaultToastMessage);
        }
      },
      goContactos(){
        this.$router.push({ name: 'Contactos' });
      },
      async AddFirmante(){
        if (!this.readyToAdd) {
          let msg = 'Seleccione un contacto y escriba su rol para poder agregarlo como firmante.';
          if (this.hasFields) msg += '<br>En caso de que el firmante deba ocupar un campo de firma, no olvide seleccionar<br>el campo de firma correspondiente.';
          this.$toast.error(msg);
          return;
        }
        const defaultToastMessage = 'Error al agregar firmante.';
        const defaultConsoleMessage = 'AddFirmante error';
        try {
          this.awaitingResponse = true;
          const doc = this.doc[0];
          console.debug('firmante', JSON.parse(JSON.stringify(this.firmante)));
          /*console.log("Version: %o", doc.version);
          if(doc.version === 2) {
            this.$toast.success("No se pueden añadir más firmantes, documento en proceso de firma.");
            return;
          }*/
          const clienteId = doc.cliente.id;
          const documentoId = doc.id;
          const firmante = this.firmante;
          firmante.field = this.campo;
          //delete firmante['cliente'];
          const result = await this.$store.dispatch('addFirmante', {clienteId, documentoId, firmante});
          if (result === null) {
            console.error(defaultConsoleMessage);
            this.$toast.error(defaultToastMessage);
            this.stopWait();
            return;
          }
          this.pageEventHandler();
          this.$toast.success("Agregado Firmante: " + firmante.contacto.nombre);
          this.selectedContacto = [];
          this.firmante.contacto = {};
          this.firmante.razon = '';
          this.campo = '';
        }catch (e) {
          consoleErrorMessage(e, defaultConsoleMessage);
          toasterErrorMessage(this.$toast.error, e, defaultToastMessage);
        }
        this.stopWait();
      },
      openComponent(component, activator = 'activatorButton') {
        const tryParameters = {
          count: 0,
          max: 15,
          interval: 100,
        };
        const element = this.$refs[component].$refs[activator].$el;
        tryClick(element, tryParameters);
      },
      rowSelected(obj) {
        // console.debug('rowSelected object %o', obj);
        if (this.selectedContacto.length > 0) {
          const sel = this.selectedContacto[0];
          this.selectedContacto = [];
          if (sel.id !== obj.id) this.selectedContacto.push(obj);
        } else this.selectedContacto.push(obj);
      },
      stopWait() {
        var self = this;
        window.setTimeout((obj) => { obj.awaitingResponse = false; }, 500, self);
      },
    },
    watch: {
      dialog() {
        if (this.dialog) {
          if (this.firstLoad) this.firstLoad = false;
          else this.pageEventHandler();
        } else {
          this.selectedContacto = [];
          this.firmante.razon = '';
        }
      },
      options() {
        console.debug('watch options', this.options);
        this.pageEventHandler();
      },
      selectedContacto() {
        if (this.selectedContacto.length === 0) {
          this.firmante.contacto = {};
        } else {
          this.firmante.contacto = this.selectedContacto[0];
        }
      },
    },
  }
</script>